<template>
  <v-btn class="ml-2" color="success"
    v-bind="$props"
    v-on="$listeners"
    v-show="data"
    @click="exportToExcel"
    :loading="isLoading"
  >
    <v-icon>{{ mdiFileExcel }}</v-icon>
  </v-btn>
</template>

<script>
import { json2excel } from 'js2excel';
import { mdiFileExcel } from '@mdi/js';
import { VBtn } from 'vuetify/lib';

export default {
  name: 'ExportToExcel',
  props: ['data', 'name'],
  extends: VBtn,
  data() {
    return {
      mdiFileExcel,
      isLoading: false,
    };
  },
  methods: {
    async exportToExcel() {
      this.isLoading = true;
      const { data, name } = this;
      await json2excel({
        data,
        name,
        formateDate: 'yyyy/mm/dd',
      });
      this.isLoading = false;
    },
  },
};
</script>
